import React from 'react';

import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';

import {
  VideoEntityPlaceholder,
  EntityCaption,
} from '../EditPageSortableList/EditPageSortableList.styles';

export const VideoDetails = (): JSX.Element => <VideoEntityPlaceholder />;

export const VideoCaption = (entity: GenericEntityType): JSX.Element | null =>
  entity?.caption ? <EntityCaption>{entity?.caption}</EntityCaption> : null;

export default { VideoDetails, VideoCaption };
